// extracted by mini-css-extract-plugin
export default {"dearPlate":"plateStyles_dearPlate__FajWy","link":"plateStyles_link__SyqOS","close":"plateStyles_close__aBFi+"};